import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { url } from 'components/other/terms';
import { createBaseQueryWithReauth } from 'utils/baseQueryWithReauth';
export const feedbacksApi = createApi({
  reducerPath: 'feedbacks',
  baseQuery: createBaseQueryWithReauth('/feedbacks'),
  

  tagTypes: ['Feedbacks'],

  endpoints: builder => ({
  

    getFeedbacks: builder.query({
      query: ({ page = 1 } = {}) => {

        const params = {
          page, // додаємо параметр page до запиту

        };
        return {
          url: `/`,
          method: 'GET',
          params,
        };
      },
      transformResponse: (response, meta) => {
        const pagination = {
          currentPage: meta.response.headers.get('x-pagination-current-page'),
          pageCount: meta.response.headers.get('x-pagination-page-count'),
          perPage: meta.response.headers.get('x-pagination-per-page'),
          totalCount: meta.response.headers.get('x-pagination-total-count'),
        };
        return { data: response, pagination };
      },
      providesTags: ['Feedbacks'],
    }),
    returnUnreadFeedbacks: builder.query({
      query: () => ({
        url: `/unread`,
        method: 'GET',
      }),
      providesTags: ['Feedbacks'],
    }),


    acceptFeedbacks: builder.mutation({
      query: ({ id, comment }) => ({
        url: `/accept?id=${id}&comment=${comment}`,
        method: 'POST',
      }),
      invalidatesTags: ['Feedbacks'],
    }),

    declineFeedbacks: builder.mutation({
      query: ({ id, comment }) => ({
        url: `/decline?id=${id}&comment=${comment}`,
        method: 'POST',
      }),
      invalidatesTags: ['Feedbacks'],
    }),
  }),
});

export const {

  useAcceptFeedbacksMutation,
  useDeclineFeedbacksMutation,
  useGetFeedbacksQuery,
  useReturnUnreadFeedbacksQuery
} = feedbacksApi;
